import { t } from "@helpers/translate";
import React, { FC, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { Trans } from "@helpers/translate";
import Icon from "../Icon";

interface ISelectItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  key: any;
  value: string;
}

interface ISelectProps {
  onChange: (item: ISelectItemProps) => void;
  items: ISelectItemProps[];
  value?: string; // key
  className?: string;
}

export const SortSelect: FC<ISelectProps> = ({
  onChange,
  items,
  value,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const valueSelected = useMemo(() => {
    return items.find((i) => i.key === value);
  }, [items, value]);

  return (
    <div className="flex">
      {isOpen && (
        <button
          onClick={() => {
            setIsOpen(false);
          }}
          tabIndex={-1}
          className="fixed inset-0 h-full w-full cursor-default"
        ></button>
      )}
      <div className="flex relative">
        <button
          onClick={() => {
            setIsOpen((old) => !old);
          }}
          className={twMerge("flex flex-row items-center px-6 py-4", className)}
        >
          {valueSelected?.value
            ? `${t({
                id: "search.sort",
                message: "Sort",
              })} | ${valueSelected?.value}`
            : "Select"}
          <svg
            className={`fill-current h-4 w-4 ml-4 ${
              isOpen ? "transform rotate-180" : ""
            } `}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title id="GWGLogoTitle">
              {t({
                id: "common.svg.title",
                message: `GoWithGuide`,
              })}
            </title>
            <desc id="GWGLogoDesc">
              <Trans id="common.svg.description">
                Find your perfect tour guide at GoWithGuide. Relax and cherish
                unforgettable tours with loved ones. Create personalized tours
                for a truly memorable trip!
              </Trans>
            </desc>
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </button>
        <div
          className={`absolute top-12 left-0 right-0 ${
            isOpen ? "" : "hidden"
          } z-10 border rounded-xl`}
        >
          <div className="flex flex-col bg-white rounded-xl">
            {items.map((item, key) => (
              <button
                key={`${item.key}-${key}`}
                className="flex flex-row p-4 hover:bg-gray-100 rounded-xl whitespace-nowrap"
                onClick={() => {
                  setIsOpen(false);
                  onChange(item);
                }}
              >
                <div
                  className={`flex items-center border p-0.5 rounded-full text-gray-400 mr-2 ${
                    item.key === valueSelected?.key
                      ? "border-secondary bg-secondary text-white"
                      : "bg-white"
                  }`}
                >
                  <Icon icon="check" size="xs" />
                </div>
                <div
                  className={`${
                    item.key === valueSelected?.key
                      ? "text-secondary"
                      : "text-black"
                  }`}
                >
                  {item.value}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
